import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import {createTheme, makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Hidden from '@material-ui/core/Hidden';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Tooltip from '@material-ui/core/Tooltip';
import NavList from './listItems';
import MainPage from "../presentation/MainPage";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {Link, Redirect, Route, Switch} from "react-router-dom";
import SignIn from "../auth/SignIn";
import Register from "../auth/Register";
import DelegationPDF from "../generators/DelegationGenerator";
import DelegationGenerator from "../generators/DelegationGenerator";
import ConfirmationGenerator from "../generators/ConfirmationGenerator";
import FuneralRecordGenerator from '../generators/FuneralRecordGenerator';
import CremationGenerator from '../generators/CremationGenerator';
import CrematoriumEvidenceListGenerator from '../generators/CrematoriumEvidenceListGenerator';
import RegistryOfficeGenerator from '../generators/RegistryOfficeGenerator';
import InternationalTransportFormGenerator from '../generators/InternationalTransportFormGenerator';
import AutopsyReportRequestGenerator from '../generators/AutopsyReportRequestGenerator';
import AutopsyRefusalGenerator from '../generators/AutopsyRefusalGenerator';
import DeathExaminationConfirmationGenerator from '../generators/DeathExaminationConfirmationGenerator';
import InvoiceGenerator from '../generators/InvoiceGenerator';
import DeliveryNoteGenerator from '../generators/DeliveryNoteGenerator';
import ApplicationGenerator from "../generators/ApplicationGenerator";
import FetalRemainsApplicationGenerator from "../generators/FetalRemainsApplicationGenerator";
import UrnApplication from "../generators/UrnApplication";
import DocumentsSigningGenerator from "../generators/DocumentsSigningGenerator";
import AuthService from "../../services/auth.service";
import FuneralForm from "../form/FuneralForm";
import {NotificationContainer, NotificationManager} from "react-notifications";
import 'react-notifications/lib/notifications.css';
import FullList from "../presentation/FullList";
import TaskList from "../presentation/TaskList";
import TasksDashboard from "../settings/TasksDashboard";
import {ThemeProvider} from '@material-ui/core';
import FuneralDetails from "../presentation/FuneralDetails";
import PlaceForm from "../form/PlaceForm";
import EvidenceForm from "../form/EvidenceForm";
import ProfileDashboard from "../settings/ProfileDashboard";
import ServiceDashboard from "../settings/ServicesDashboard";
import ServicesForm from "../form/ServicesForm";
import ProductsDashboard from "../settings/ProductsDashboard";
import ProductsForm from "../form/ProductsForm";
import AdminLogs from "../presentation/AdminLogs";
import ExportEvidence from "../settings/ExportEvidence";
import Information from "../presentation/Information";
import DefinedTexts from "../settings/DefinedTexts";
import InformationPaperGenerator from "../generators/InformationPaperGenerator";
import CoffinLabelGenerator from "../generators/CoffinLabelGenerator";
import CardsGenerator from "../generators/CardsGenerator";
import GuideExcel from "../presentation/GuideExcel";
import GDPRpolicy from "../presentation/GDPRpolicy";
import Policy from "../presentation/Policy";
import PricesGenerator from "../generators/PricesGenerator";
import Contact from '../presentation/Contact';
import Statistics from '../presentation/Statistics';
import DoctorsServices from "../presentation/DoctorsServices";
import RegistryOfficeList from "../presentation/RegistryOfficeList";
import OrganizationDashboard from "../settings/OrganizationDashboard";
import ApiDocumentation from '../presentation/ApiDocumentation';
import TrashBin from "../presentation/TrashBin";
import {canAccessPath} from "../../helpers/permissions";

const drawerWidth = 260;

const APPBAR_HEIGHT = 68;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        background: '#f7f4ee',
        height: '100vh',
        overflow: 'hidden',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        background: 'linear-gradient(135deg, #2c4767 0%, #1e3553 100%)',
        boxShadow: '0 4px 18px rgba(30, 53, 83, 0.22)',
        borderBottom: '1px solid rgba(176, 141, 87, 0.30)',
        left: 0,
        right: 0,
        width: '100%',
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 2,
            background: 'linear-gradient(90deg, transparent 0%, rgba(176, 141, 87, 0.6) 30%, rgba(176, 141, 87, 0.6) 70%, transparent 100%)',
        },
    },
    toolbar: {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        minHeight: APPBAR_HEIGHT,
        height: APPBAR_HEIGHT,
        gap: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(2),
        },
    },
    menuButton: {
        marginRight: theme.spacing(1),
        color: '#ffffff',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.08)',
        },
    },
    menuButtonHidden: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    brandWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexGrow: 1,
        minWidth: 0,
    },
    appBarBrandMark: {
        width: 38,
        height: 38,
        borderRadius: 10,
        background: 'rgba(176, 141, 87, 0.18)',
        border: '1.5px solid #b08d57',
        color: '#f0d9a8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: '0.92rem',
        letterSpacing: 1,
        flexShrink: 0,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    brandTextWrap: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
    },
    brandTitle: {
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '1.05rem',
        letterSpacing: 1.5,
        textTransform: 'uppercase',
        lineHeight: 1.1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.95rem',
            letterSpacing: 1,
        },
    },
    brandSub: {
        color: 'rgba(240, 217, 168, 0.85)',
        fontSize: '0.68rem',
        letterSpacing: 1.4,
        textTransform: 'uppercase',
        marginTop: 2,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    actionsWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    appBarAction: {
        textDecoration: 'none',
        color: '#ffffff',
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        padding: theme.spacing(0.75, 1.5),
        borderRadius: 8,
        fontSize: '0.88rem',
        fontWeight: 600,
        letterSpacing: 0.3,
        transition: 'background 150ms ease, color 150ms ease',
        '&:hover': {
            background: 'rgba(176, 141, 87, 0.18)',
            color: '#f0d9a8',
        },
        '& svg': {
            fontSize: 18,
        },
    },
    appBarActionLabel: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    appBarActionAdmin: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    logoutAction: {
        marginLeft: theme.spacing(0.5),
        background: 'rgba(255, 255, 255, 0.06)',
        '&:hover': {
            background: 'rgba(248, 50, 69, 0.20)',
            color: '#ffd9df',
        },
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        marginTop: APPBAR_HEIGHT,
        height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
        background: '#fbfaf7',
        borderRight: '1px solid rgba(176, 141, 87, 0.22)',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '4px 0 16px rgba(44, 71, 103, 0.04)',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperMobile: {
        width: drawerWidth,
        background: '#fbfaf7',
        display: 'flex',
        flexDirection: 'column',
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    mobileDrawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0.5, 1),
        minHeight: 48,
        background: '#1e3553',
    },
    mobileCloseBtn: {
        color: '#f0d9a8',
    },
    drawerScroll: {
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    appBarSpacer: {
        minHeight: APPBAR_HEIGHT,
        height: APPBAR_HEIGHT,
        flexShrink: 0,
    },
    mainColumn: {
        flexGrow: 1,
        minWidth: 0,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 1 auto',
        minWidth: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        background: '#f7f4ee',
    },
    contentNoTopColumn: {
        flex: '1 1 auto',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    contentNoTop: {
        flex: '1 1 auto',
        minWidth: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    mtTop: {
        marginTop: theme.spacing(4),
    },
}));


const theme = createTheme({
    palette: {
        primary: {
            main: "#2c4767",
            dark: "#1e3553",
            light: 'rgba(44, 71, 103, 0.12)',
            contrastText: '#ffffff',
        },
        secondary: {
            main: "#b08d57",
            dark: "#8a6e42",
            light: 'rgba(176, 141, 87, 0.16)',
            contrastText: '#ffffff',
        },
        background: {
            default: "#f7f4ee",
            paper: "#ffffff",
        },
        text: {
            primary: "#1a2733",
            secondary: "#5a6675",
        },
    },
    typography: {
        fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        h1: {fontWeight: 700},
        h2: {fontWeight: 700},
        h3: {fontWeight: 700},
        h4: {fontWeight: 700},
        h5: {fontWeight: 600},
        h6: {fontWeight: 600},
        button: {textTransform: 'none', fontWeight: 600, letterSpacing: 0.3},
    },
    shape: {
        borderRadius: 10,
    },
    overrides: {
        MuiAppBar: {
            root: {
                transform: 'translateZ(0)'
            }
        },
        MuiPaper: {
            rounded: {
                borderRadius: 12,
            },
        },
        MuiTableCell: {
            head: {
                fontWeight: 600,
            },
        },
    },
    props: {
        MuiIconButton: {
            disableRipple: true
        }
    }
})

export default function Dashboard(props) {
    const classes = useStyles();
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    const [open, setOpen] = React.useState(true);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerOpen = () => {
        if (isMobile) {
            setMobileOpen(true);
        } else {
            setOpen(true);
        }
    };
    const handleDrawerClose = () => {
        if (isMobile) {
            setMobileOpen(false);
        } else {
            setOpen(false);
        }
    };
    const [showModeratorBoard, setShowModeratorBoard] = useState(false);
    const [showAdminBoard, setShowAdminBoard] = useState(false);
    const [currentUser, setCurrentUser] = useState(undefined);

    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if (user) {
            setCurrentUser(user);
            if (user.roles.includes("ROLE_USER")) {
                logOut();
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);

            }
            setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
            setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
            AuthService.refreshCurrentUser().then((refreshedUser) => {
                setCurrentUser(refreshedUser);
                setShowModeratorBoard(refreshedUser.roles.includes("ROLE_MODERATOR"));
                setShowAdminBoard(refreshedUser.roles.includes("ROLE_ADMIN"));
            }).catch(() => {});
        }
    }, []);

    const logOut = () => {
        AuthService.logout();
        setCurrentUser(undefined);
    };

    const PrivateModeratorRoute = ({component: Component, ...rest}) => (
        <Route {...rest} render={(props) => (
            showModeratorBoard === true && canAccessPath(props.location.pathname)
                ? <Component {...props} />
                : <Redirect to={{
                    pathname: showModeratorBoard ? '/domov' : '/',
                    state: {from: props.location}
                }}/>
        )}/>
    )

    const PrivateAdminRoute = ({component: Component, ...rest}) => (
        <Route {...rest} render={(props) => (
            showAdminBoard === true
                ? <Component {...props} />
                : <Redirect to={{
                    pathname: '/',
                    state: {from: props.location}
                }}/>
        )}/>
    )

    const PrivateModeratorOrAdminRoute = ({component: Component, ...rest}) => (
        <Route {...rest} render={(props) => (
            (showModeratorBoard === true || showAdminBoard === true) && canAccessPath(props.location.pathname)
                ? <Component {...props} />
                : <Redirect to={{
                    pathname: showModeratorBoard ? '/domov' : '/',
                    state: {from: props.location}
                }}/>
        )}/>
    )

    const PrivateOrganizationOwnerRoute = ({component: Component, ...rest}) => (
        <Route {...rest} render={(props) => (
            showModeratorBoard === true && currentUser?.isOrganizationOwner !== false
                ? <Component {...props} />
                : <Redirect to={{pathname: '/domov', state: {from: props.location}}}/>
        )}/>
    )

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <CssBaseline/>
                {currentUser &&
                <>
                    <AppBar position="absolute" className={classes.appBar}>
                        <Toolbar className={classes.toolbar}>
                            <IconButton
                                edge="start"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                            >
                                <MenuIcon/>
                            </IconButton>
                            <div className={classes.brandWrap}>
                                <div className={classes.appBarBrandMark}>MP</div>
                                <div className={classes.brandTextWrap}>
                                    <span className={classes.brandTitle}>Moderné pohrebníctvo</span>
                                    <span className={classes.brandSub}>Pohrebná aplikácia</span>
                                </div>
                            </div>
                            <div className={classes.actionsWrap}>
                                <Tooltip title="Odhlásiť sa">
                                    <Link to="/" onClick={logOut} className={`${classes.appBarAction} ${classes.logoutAction}`} aria-label="Odhlásiť sa">
                                        <ExitToAppIcon/>
                                        <span className={classes.appBarActionLabel}>Odhlásiť sa</span>
                                    </Link>
                                </Tooltip>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Hidden mdUp implementation="css">
                        <Drawer
                            variant="temporary"
                            classes={{paper: classes.drawerPaperMobile}}
                            open={mobileOpen}
                            onClose={handleDrawerClose}
                            ModalProps={{keepMounted: true}}
                        >
                            <div className={classes.mobileDrawerHeader}>
                                <IconButton onClick={handleDrawerClose} aria-label="zavrieť menu" className={classes.mobileCloseBtn}>
                                    <ChevronLeftIcon/>
                                </IconButton>
                            </div>
                            <div className={classes.drawerScroll}>
                                <NavList onItemClick={handleDrawerClose} showBrand={true} showAdminBoard={showAdminBoard}/>
                            </div>
                        </Drawer>
                    </Hidden>
                    <Hidden smDown implementation="css">
                        <Drawer
                            variant="permanent"
                            classes={{
                                paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                            }}
                            open={open}
                        >
                            <div className={classes.drawerScroll}>
                                <NavList showBrand={false} showAdminBoard={showAdminBoard}/>
                            </div>
                        </Drawer>
                    </Hidden>
                </>
                }
                <div className={currentUser ? classes.mainColumn : classes.contentNoTopColumn}>
                    {currentUser && <div className={classes.appBarSpacer}/>}
                    <main className={currentUser ? classes.content : classes.contentNoTop}>
                        <Switch>
                            <Route exact path="/" component={SignIn}/>
                            <Route exact path="/informacie" component={Information}/>
                            <Route exact path="/gdpr" component={GDPRpolicy}/>
                            <Route exact path="/podmienky" component={Policy}/>
                            <Route exact path="/navod_excel" component={GuideExcel}/>
                            <Route exact path="/api-dokumentacia" render={(props) => AuthService.getCurrentUser()
                                ? <ApiDocumentation {...props}/>
                                : <Redirect to={{pathname: '/', state: {from: props.location}}}/>}/>
                            <PrivateAdminRoute exact path="/register" component={Register}/>
                            <PrivateAdminRoute exact path="/logs" component={AdminLogs}/>
                            <PrivateModeratorRoute path="/domov" component={MainPage}/>
                            <PrivateOrganizationOwnerRoute path="/profil" component={ProfileDashboard}/>
                            <PrivateOrganizationOwnerRoute path="/organizacia" component={OrganizationDashboard}/>
                            <PrivateOrganizationOwnerRoute path="/kos" component={TrashBin}/>
                            <PrivateModeratorRoute path="/definovane_texty" component={DefinedTexts}/>
                            <PrivateModeratorRoute path="/splnomocnenie" component={DelegationPDF}/>
                            <PrivateModeratorRoute path="/sluzby" component={ServiceDashboard}/>
                            <PrivateModeratorRoute path="/produkty" component={ProductsDashboard}/>
                            <PrivateModeratorRoute path="/generovanie_evidencie" component={ExportEvidence}/>
                            <PrivateModeratorRoute path="/sluzby_obhliadajucich_lekarov" component={DoctorsServices}/>
                            <PrivateModeratorRoute path="/novy-pohreb" component={(props) => <FuneralForm {...props}
                                                                                                          key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/upravit"
                                                   component={(props) => <FuneralForm {...props}
                                                                                      key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/zoznam" component={FullList} {...props}
                                                   key={window.location.pathname}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/miesto"
                                                   component={(props) => <PlaceForm {...props}
                                                                                    key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/miesto/:funeral_id/:place_id"
                                                   component={(props) => <PlaceForm {...props}
                                                                                    key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/info" component={FuneralDetails} {...props}
                                                   key={window.location.pathname}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/splnomocnenie"
                                                   component={DelegationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/potvrdenie"
                                                   component={ConfirmationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/zaznam_o_pohrebe"
                                                   component={FuneralRecordGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/povolenie_na_kremaciu"
                                                   component={CremationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/sprava_pre_matriku"
                                                   component={RegistryOfficeGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/medzinarodny_prepravny_formular"
                                                   component={InternationalTransportFormGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/ziadost_o_pitevnu_spravu"
                                                   component={AutopsyReportRequestGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/odmietnutie-pitvy-zakonny-zastupca"
                                                   component={AutopsyRefusalGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/odmietnutie-pitvy"
                                                   component={AutopsyRefusalGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/potvrdenie-o-prehliadke-mrtveho-tela"
                                                   component={DeathExaminationConfirmationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/faktura"
                                                   component={InvoiceGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/dodaci_list"
                                                   component={DeliveryNoteGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/ziadost-plod"
                                                   component={FetalRemainsApplicationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/evidencny-list"
                                                   component={CrematoriumEvidenceListGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/ziadost"
                                                   component={ApplicationGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/ziadost_urna"
                                                   component={UrnApplication}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/gdpr" component={DocumentsSigningGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/informacny_list" component={InformationPaperGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/stitok_rakva" component={CoffinLabelGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/cennik" component={PricesGenerator}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/karticky" component={CardsGenerator}/>

                            <PrivateModeratorRoute path="/pohreb/produkty/:funeral_id"
                                                   component={(props) => <ProductsForm {...props}
                                                                                       key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/:funeral_id/evidencia"
                                                   component={(props) => <EvidenceForm {...props}
                                                                                       key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/evidencia/:funeral_id/:evidence_id"
                                                   component={(props) => <EvidenceForm {...props}
                                                                                       key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/pohreb/sluzby/:funeral_id"
                                                   component={(props) => <ServicesForm {...props}
                                                                                       key={window.location.pathname}/>}/>
                            <PrivateModeratorRoute path="/ulohy" component={TaskList} {...props}
                                                   key={window.location.pathname}/>

                            <PrivateModeratorRoute path="/definovane_ulohy" component={TasksDashboard} {...props}
                                                   key={window.location.pathname}/>

                            <PrivateModeratorOrAdminRoute path="/kontakty" component={Contact} {...props}
                                                          key={window.location.pathname}/>

                            <PrivateModeratorRoute path="/statistiky" component={Statistics} {...props}
                                                   key={window.location.pathname}/>

                            <PrivateModeratorOrAdminRoute path="/matrika" component={RegistryOfficeList} {...props}
                                                          key={window.location.pathname}/>
                        </Switch>
                        <div className={classes.mtTop}/>
                        <NotificationContainer/>
                    </main>
                </div>
            </div>
        </ThemeProvider>
    );
}
